import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	MainHeaderButtonsWrapper: {
		flex: "none",
		marginLeft: "auto",
		"& > *": {
			margin: theme.spacing(1),
		},
	},
}));

const MainHeaderButtonsWrapper = ({ children, className = "" }) => {
	const classes = useStyles();

	return (
		<div className={`${classes.MainHeaderButtonsWrapper} ${className}`}>
			{children}
		</div>
	);
};

export default MainHeaderButtonsWrapper;

